(function () {
  function initSingleAccordion() {
    // Cible les <details> des onglets produit dans la section product information
    const productInfo = document.querySelector('.product-information--inner');
    if (!productInfo) return;

    const detailsList = productInfo.querySelectorAll('.product__accordion details');
    if (detailsList.length < 2) return;

    detailsList.forEach((details) => {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        detailsList.forEach((other) => {
          if (other !== details && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSingleAccordion);
  } else {
    initSingleAccordion();
  }
})();